module.exports = __webpack_public_path__ + "img/predictive_dashboard1.18a53b0f.png";